<template>
  <div id="media-title-component">
    <div class="flex justify-center pb-[40px] md:pb-16">
      <div class="text-center">
        <div class="fix-width-m-auto text-grey-1">
          <h1 class="px-6" v-html="mediaTitleContent.heading" data-test="mediaHeading" />
          <div class="intro-1 m-auto py-8 px-[20px] md:px-0" data-test="mediaSubHeading">
            {{ mediaTitleContent.subHeading }}
          </div>
          <img :src="NewspaperLady" alt="Newspaper Lady" class="m-auto my-4 w-76" data-test="newspaperLadyImage"/>
        </div>
      </div>
    </div>
    <OffsetCurve fill="primary" />
  </div>
</template>

<script lang="ts" setup>
import NewspaperLady from '@/components/SVGS/NewspaperLady.svg?url'
import OffsetCurve from '@/components/Shapes/OffsetCurve.vue'

interface Props {
  mediaTitleContent: {
    heading: string
    subHeading: string
    footer: string
  }
}

defineProps<Props>()
</script>

<style  scoped>
@media (min-width: 768px) {
  #media-logos svg {
    width: 1151px;
    height: auto;
  }
}
</style>
